// 261029 P1 A4 — vòng poll `workflow-status` DỪNG khi tab ẩn, THUẦN (không React / antd ⇒ test bằng jest fake timers).
// Luật: tick mỗi `intervalMs` · request trước chưa về ⇒ bỏ nhịp · tab ẩn (`document.hidden`) ⇒ bỏ nhịp, KHÔNG gọi gì · tab hiện lại ⇒ chạy NGAY một tick đầy đủ
// (cùng `tick` của nhịp poll: caller truyền `getPlanJobs` rồi status, vì `GET jobs` là nơi dọn job legacy quá hạn) rồi tiếp tục nhịp cũ.
// Chỉ vòng status của FilmWorkflowPage dùng; các poller khác (thẻ bối cảnh, hướng, phiếu review) ngoài phạm vi.
export interface VisiblePollEnv {
  hidden: () => boolean;
  /** Đăng ký lắng nghe đổi hiển thị; trả hàm huỷ. */
  onVisibilityChange: (cb: () => void) => () => void;
  setInterval: (fn: () => void, ms: number) => unknown;
  clearInterval: (id: unknown) => void;
}

export const browserPollEnv = (): VisiblePollEnv => ({
  hidden: () => typeof document !== 'undefined' && document.hidden === true,
  onVisibilityChange: (cb) => {
    if (typeof document === 'undefined') return () => undefined;
    document.addEventListener('visibilitychange', cb);
    return () => document.removeEventListener('visibilitychange', cb);
  },
  setInterval: (fn, ms) => setInterval(fn, ms),
  clearInterval: (id) => clearInterval(id as ReturnType<typeof setInterval>),
});

export function startVisiblePoll(tick: () => Promise<unknown> | unknown, intervalMs: number, env: VisiblePollEnv = browserPollEnv()): () => void {
  let inflight = false;
  let stopped = false;
  const run = () => {
    if (stopped || inflight || env.hidden()) return;
    inflight = true;
    Promise.resolve()
      .then(tick)
      .catch(() => undefined)
      .finally(() => { inflight = false; });
  };
  const timer = env.setInterval(run, intervalMs);
  const unlisten = env.onVisibilityChange(() => { if (!env.hidden()) run(); });
  return () => { stopped = true; env.clearInterval(timer); unlisten(); };
}
